(function($){
  'use strict';

  if(!$.tangible){
    $.tangible = new Object();
  };

  $.tangible.multiSelect = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.init = function(){
      
      base.$btnMultiSelect = $('.js-toggleMultiSelectBtn');
      base.$multiSelectOptions = $('.js-multiselectOptions');

      // Opens the box of options
      base.$btnMultiSelect.click(function(e){
        e.preventDefault();
        base.$multiSelectOptions.toggleClass('is-visible');
        // Switches the state of aria-expanded
        var expanded = $(this).attr('aria-expanded') === 'true' || false;
        $(this).attr('aria-expanded', !expanded);
      });

    };


    base.init();

  };

  $.fn.tangible_multiSelect = function(options){
    return this.each(function(){
      (new $.tangible.multiSelect(this, options));
    });
  };

})(jQuery);